import API from './API.js'
import axios from 'axios'

export default class Questions extends API {
  constructor() {
    super('questions')
  }

  async CourseQuestions(course_id,params) {
    // console.log("api", params);
    const response = await axios.get(`questions/course-questions/${course_id}`,{params})
    return response.data
  }
 }
